import { ThemeOptions } from "@mui/material";
import {
  commonBorderRadius,
  generateErrorWarnInfoColors,
  MuiButton,
  MuiChip,
  MuiFilledInput,
  styleRootCommonAppBar
} from "./util/theme-generator-util";

export const likemagicFontFamilyTitle = "Matter-SemiBold";
export const likemagicFontFamilyBody = "Matter-Regular";

export const likemagicThemeConfig: ThemeOptions = {
  components: {
    MuiChip,
    MuiButton,
    MuiFilledInput,
    MuiAppBar: {
      styleOverrides: {
        root: styleRootCommonAppBar
      }
    }
  },
  shape: {
    borderRadius: commonBorderRadius
  },
  palette: {
    primary: {
      main: "#000000"
    },
    secondary: {
      main: "#000000"
    },
    ...generateErrorWarnInfoColors(),
    background: {
      default: "#EEEEEE",
      paper: "#FFFFFF"
    },
    text: {
      primary: "#000000",
      secondary: "#9E9E9E"
    },
    action: {
      disabledOpacity: 0
    },
    grey: {
      "600": "#757575"
    }
  },
  typography: {
    fontFamily: likemagicFontFamilyBody,
    h1: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyTitle,
      fontSize: "32px"
    },
    h2: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyTitle,
      fontSize: "24px"
    },
    h3: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyTitle,
      fontSize: "20px"
    },
    h4: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyTitle,
      fontSize: "16px"
    },
    subtitle1: {
      fontStyle: "normal",
      fontFamily: likemagicFontFamilyBody,
      fontSize: "24px"
    },
    body1: {
      fontFamily: likemagicFontFamilyBody,
      fontStyle: "normal",
      fontSize: "16px"
    },
    body2: {
      fontFamily: likemagicFontFamilyBody,
      fontStyle: "normal",
      fontSize: "14px"
    }
  }
};
